import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../redux/hooks';

interface AuthGuardProps {
  children: ReactNode;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const user = useAppSelector((state) => state.authenticator.user);

  // Check if user is authenticated (has a token)
  if (!user.token) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
